const queryKeyFactory = {
  reports: (studyId?: string, reportType?: string) => ['reports', studyId, reportType],
}

export default queryKeyFactory
